var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('p'),_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.redirectUrl,"type":"button"}},[_vm._v(" Ir a Portabilidad ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"mb-4"},[_c('strong',[_vm._v("El número no es Virgin Mobile")])])
}]

export { render, staticRenderFns }